import spinner from "../utils/rbmc.spinner";
import addressErrors from "../address-management/rbmc.address-error-handling";
import urlUtils from '../utils/rbmc.url-utils';

const addressManagement = {
    addressContainer:  undefined,
    addressForm:       undefined,
    buttonAddNew:      undefined,
    buttonSaveNew:     undefined,
    buttonSaveChanged: undefined,
    addressMirror:     undefined,

    init() {
        addressManagement.addressContainer  = $('.address__container');
        addressManagement.addressForm       = $('#address-form');
        addressManagement.buttonSaveNew     = $('#address__button-save-new');
        addressManagement.buttonSaveChanged = $('#address__button-save-change');
        addressManagement.buttonAddNew      = $('#address__add-new');
        addressManagement.addressMirror     = $('#address-form__country-mirror');
        addressManagement.bindEvents();
        addressManagement.bindTooltips();
    },

    fillFormForAddressChange($currentAddressItem) {
        addressErrors.removeErrors();
        addressManagement.buttonAddNew.fadeIn(200);
        addressManagement.buttonSaveNew.hide();
        addressManagement.addressForm.attr('action',
                `${urlUtils.getBaseUrl()}my-account/edit-address/${$currentAddressItem.data('address-id')}`);
        addressManagement.addressForm.data('address-id', $currentAddressItem.data('address-id'));
        addressManagement.addressForm.find('#address-form__title').val($currentAddressItem.data('title'));
        addressManagement.addressForm.find('#address-form__first-name').val($currentAddressItem.data('first-name'));
        addressManagement.addressForm.find('#address-form__last-name').val($currentAddressItem.data('last-name'));
        addressManagement.addressForm.find('#address-form__address').val($currentAddressItem.data('street'));
        addressManagement.addressForm.find('#address-form__firm').val($currentAddressItem.data('firm'));
        addressManagement.addressForm.find('#address-form__zip').val($currentAddressItem.data('zip'));
        addressManagement.addressForm.find('#address-form__city').val($currentAddressItem.data('city'));
        addressManagement.addressForm.find('#address-form__phone').val($currentAddressItem.data('phone'));
        addressManagement.addressForm.find('#address-form__country').prop('selectedIndex',
                addressManagement.addressForm.find(
                        `#address-form__country option[value=${$currentAddressItem.data('iso-code')}]`).index()
        );
        addressManagement.addressForm.find('#address-form__country').selectpicker('refresh');
        addressManagement.addressForm.find('#address-form__address-id').val($currentAddressItem.data('address-id'));
        addressManagement.addressForm.find('#address__default-address').prop('checked',
                $currentAddressItem.data('default-address')
        );
        addressManagement.addressMirror.val($currentAddressItem.data('iso-code'));
        addressManagement.buttonSaveChanged.show();
    },

    bindTooltips() {
        const $eraseDefaultAddress = $('.address__default-address').find('.address__icon-delete');
        $eraseDefaultAddress.tooltip({
            html:      true,
            container: '.address__default-address',
            title:     addressManagement.tooltipTemplate(
                    $eraseDefaultAddress.data('tooltip-title'),
                    $eraseDefaultAddress.data('tooltip-confirm'),
                    $eraseDefaultAddress.data('tooltip-cancel'),
                    'address__confirm-delete'
            ),
            placement: 'top',
            trigger:   'manual'
        });
    },

    tooltipTemplate(title, confirm, cancel, tooltipClass) {
        return `<p>${title}</p>
            <div class="tooltip-buttons ${tooltipClass}">
                <div type="button" class="btn btn-secondary address__tooltip-cancel">${cancel}</div>
                <div type="button" class="btn btn-primary address__tooltip-confirm">${confirm}</div>
            </div>`;
    },

    submitAddress() {
        addressManagement.addressContainer.find('.address__item').animate('opacity', 0.5);
        spinner.spinnerVisibility(true);

        $.ajax({
            url:    addressManagement.addressForm.attr('action'),
            method: 'POST',
            data:   addressManagement.addressForm.serialize()
        }).done(function (response) {
            if (!response.success) {
                addressErrors.removeErrors();
                addressErrors.handleOnError(response.fieldErrors);
                $(window).scrollTop(0);
                spinner.spinnerVisibility(false);
            } else {
                addressManagement.refreshAddressSection();
                addressManagement.addressForm.fadeOut(200);
                addressManagement.buttonAddNew.fadeIn(200);
                addressManagement.addressContainer
                                 .find('.address__item')
                                 .animate('opacity', 1);
            }
        });
    },

    changeDefaultAddress() {
        $.ajax({
            url:    `${urlUtils.getBaseUrl()}my-account/set-default-address/${$(this).data('address-id')}`,
            method: 'GET',
        }).done(function () {
            addressManagement.refreshAddressSection();
        });
    },

    newAddressForm() {
        addressManagement.buttonSaveChanged.hide();
        addressManagement.buttonSaveNew.show();
        addressManagement.resetFormFields();
        addressManagement.addressForm.fadeIn(200);
        addressManagement.buttonAddNew.fadeOut(200);
        addressManagement.addressForm.attr('action', `${urlUtils.getBaseUrl()}my-account/add-address`);
    },

    resetFormFields() {
        addressErrors.removeErrors();
        addressManagement.addressForm.find('input[type=text]').val('');
        addressManagement.addressForm.find('input[type=checkbox]').prop('checked', false);
        addressManagement.addressForm.find('#address-form__country').prop('selectedIndex', 0);
        addressManagement.addressForm.find('#address-form__country').selectpicker('refresh');
    },

    deleteAddress($this) {
        $this.animate({opacity: 0.5}, 200);
        spinner.spinnerVisibility(true);
        $.ajax({
            url:     `${urlUtils.getBaseUrl()}my-account/remove-address/${$this.data('address-id')}`,
            success: function () {
                //after success delete, refresh container
            }
        }).done(function () {
            addressManagement.refreshAddressSection();
        });
    },

    refreshAddressSection() {
        addressManagement.addressContainer
                         .find('.address__address-listing')
                         .load(`${window.location.pathname} .address__address-listing > *`, function () {
                             addressManagement.bindTooltips();
                             spinner.spinnerVisibility(false);
                         });
    },

    bindEvents() {
        addressManagement.addressContainer.on('click', '.address__icon-edit', function () {
            addressManagement.formVisibility(true);
            addressManagement.fillFormForAddressChange(
                    $(this).parent()
            );
        });

        addressManagement.addressContainer.on('click', '#address__add-new',
                addressManagement.newAddressForm
        );

        addressManagement.addressForm.on('submit', function (evt) {
            evt.preventDefault();
            addressManagement.submitAddress();
        });

        addressManagement.addressContainer.on('click', '.address__icon-delete', function () {

            let $this = $(this);
            if ($this.parent().data('default-address')) {
                $this.tooltip('show');
            } else {
                //just delete, send address id to function call
                addressManagement.deleteAddress($this.parent());
            }
        });

        addressManagement.addressContainer.on('change',
                '.address__item [id*=address__set-default-address]',
                addressManagement.changeDefaultAddress
        );

        //set iso code on select change
        addressManagement.addressForm.find('#address-form__country').on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
            let currentCountryIsoCode;

            // workaround for RBMC-3253 (autofill with Chrome)
            if (clickedIndex === undefined) {
                currentCountryIsoCode = e.currentTarget.selectedOptions[0].dataset.isoCode;
            } else {
                currentCountryIsoCode = $(this).find('option').eq(clickedIndex).data('iso-code');
            }
            addressManagement.addressMirror.val(currentCountryIsoCode);
        });
        // tooltip action for deleting default address
        addressManagement.addressContainer.on('click', '.address__tooltip-cancel', function () {
            $('.address__default-address').find('.address__icon-delete').tooltip('hide');
        });
        addressManagement.addressContainer.on('click', '.address__tooltip-confirm', function () {
            $(this).parents('.address__default-address').hide();
            addressManagement.deleteAddress($(this).parents('.address__default-address'));
        });
    },

    formVisibility(visible) {
        if (visible) {
            addressManagement.addressForm.fadeIn(200);
            $(document).scrollTop(
                    addressManagement.addressForm.offset().top - 90
            );
        } else {
            addressManagement.addressForm.fadeOut(200);
        }
    },

};

$(() => {
    addressManagement.init();
});
export default addressManagement;
